module.exports = __webpack_public_path__ + "img/pt_jd.e401c73c.png";